import type { IconComponent } from '@consta/icons/Icon'
import { IconKebab } from '@consta/icons/IconKebab'
import { Button } from '@consta/uikit/Button'
import { ContextMenu } from '@consta/uikit/ContextMenu'
import type { ContextMenuItem, TabAction } from '@core/core/types'
import cn from 'classnames'
import type { TabId } from 'common/types'
import type { FC, MouseEventHandler } from 'react'
import { useRef, useState } from 'react'

import css from './Tab.css'

type Props = {
  icon?: IconComponent
  label: string
  selected: boolean
  onChange: (e: TabAction) => void
  id: TabId
  isWorkAreaActive: boolean
}

export const Tab: FC<Props> = ({ id, label, icon: Icon, onChange, selected, isWorkAreaActive }) => {
  const [menuVisibility, setMenuVisibility] = useState(false)
  const showMenu: MouseEventHandler = e => {
    e.stopPropagation()
    setMenuVisibility(true)
  }
  const hideMenu = () => {
    setMenuVisibility(false)
  }
  const menuAnchorRef = useRef(null)

  const menuItems: ContextMenuItem[] = [
    {
      label: 'Закрыть',
      group: 1,
      action: e => {
        e.stopPropagation()
        onClose(id)
      },
    },
    {
      label: 'Закрыть другие',
      group: 1,
      action: e => {
        e.stopPropagation()
        onCloseOther(id)
      },
    },
  ]

  const onSet = () => {
    onChange({ actionType: 'set', tabId: id })
  }

  const onClose = (id: TabId) => {
    onChange({ actionType: 'close', tabId: id })
    hideMenu()
  }
  const onCloseOther = (id: TabId) => {
    onChange({ actionType: 'closeOther', tabId: id })
    hideMenu()
  }

  const containerClassName = cn(css.container, {
    [css.selected]: selected,
    [css.active]: selected && isWorkAreaActive,
  })

  const tabClass = cn(css.tab, css.icon)

  return (
    <div className={containerClassName} data-testid="tab" onClick={onSet}>
      <div className={tabClass}>
        {!!Icon && <Icon className={css.iconMargin} size="s" data-testid="icon" />}
        <span className={css.label}>{label}</span>
      </div>
      <Button
        ref={menuAnchorRef}
        className={css.anchor}
        iconLeft={IconKebab}
        size="xs"
        view="clear"
        data-testid="tab__btn_show_contextMenu"
        onClick={showMenu}
      />
      <ContextMenu
        anchorRef={menuAnchorRef}
        isOpen={menuVisibility}
        size="s"
        direction="downStartLeft"
        items={menuItems}
        getItemLabel={item => item.label}
        getItemGroupId={item => item.group}
        getItemDisabled={item => item.disabled}
        getItemOnClick={item => item.action}
        data-testid="tab__contextMenu"
        onClickOutside={hideMenu}
      />
    </div>
  )
}
